import isFeatureEnabled from '~/components/common/is-feature-enabled';
import { getCurrentUser, AppState, APP_CONSTANTS } from '~/common/explicit-exports';

const Permission = APP_CONSTANTS.PERMISSIONS;

const { isWhiteLabel } = AppState;
const user = getCurrentUser();

const WorkRampAdminAppOptions = {
  TRAINING: {
    id: 0,
    title: 'Content',
    href: '/',
    src: '/images/vertnav_training_icon.svg',
    icon: 'folder-closed',
    iconName: 'folder-closed:regular',
    allowedPermissions: [Permission.ADMIN, Permission.EDITOR],
    sortOrder: 1,
  },
  REPORTING: {
    id: 1,
    title: 'Reporting',
    src: '/images/vertnav_analytics_icon.svg',
    icon: 'table',
    iconName: 'table:regular',
    newNavHref: isFeatureEnabled('data_viz_internal') ? '/admin/internal-data-viz' : '/admin/reporting',
    allowedPermissions: [Permission.ADMIN, Permission.REPORTING],
    shouldShow: () => !isWhiteLabel,
    sortOrder: 3,
    options: [
      {
        id: 0,
        title: 'Insights',
        href: '/admin/internal-data-viz',
        allowedPermissions: [Permission.ADMIN, Permission.REPORTING],
        shouldShow: () => isFeatureEnabled('data_viz_internal'),
      },
      {
        id: 1,
        title: 'Report Builder',
        href: '/admin/reporting',
        allowedPermissions: [Permission.ADMIN, Permission.REPORTING],
      },
      {
        id: 3,
        title: 'Analytics Studio',
        betaBadge: true,
        href: '/admin/dashboards',
        allowedPermissions: [Permission.ADMIN, Permission.REPORTING],
        shouldShow: () => isFeatureEnabled('fy25_q1_embedded_analytics'),
      },
    ],
  },
  SETUP: {
    id: 4,
    sortOrder: 7,
    title: 'Settings',
    href: '/admin/users',
    src: '/images/setup_icon.svg',
    icon: 'cog',
    iconName: 'controls-cog:regular',
    allowedPermissions: [
      Permission.ADMIN,
      Permission.GROUPS_MANAGEMENT,
      Permission.USERS_MANAGEMENT,
      Permission.WORKFLOWS_MANAGEMENT,
      Permission.BADGES_MANAGEMENT,
    ],
    submenus: {
      USERS: {
        id: 0,
        title: 'Users',
        href: '/admin/users',
        allowedPermissions: [Permission.ADMIN, Permission.USERS_MANAGEMENT],
      },
      GROUPS: {
        id: 1,
        title: 'Groups',
        href: '/admin/groups',
        allowedPermissions: [Permission.ADMIN, Permission.GROUPS_MANAGEMENT],
      },
      PERMISSIONS: {
        id: 2,
        title: 'Permissions',
        href: '/admin/permissions',
        allowedPermissions: [Permission.ADMIN],
        shouldShow: () => !isWhiteLabel,
      },
      BADGES: {
        id: 3,
        title: 'Badges',
        href: '/admin/badges',
        allowedPermissions: [Permission.ADMIN, Permission.BADGES_MANAGEMENT],
        shouldShow: () => !isWhiteLabel,
      },
      TAGS: { id: 4, title: 'Tags', href: '/admin/tags', allowedPermissions: [Permission.ADMIN] },
      INTEGRATIONS: {
        id: 6,
        title: 'Integrations',
        href: '/admin/integrations',
        allowedPermissions: [Permission.ADMIN],
      },
      EMAIL: {
        id: 7,
        title: 'Email',
        href: '/admin/email',
        allowedPermissions: [Permission.ADMIN],
        shouldShow: () => !isWhiteLabel,
      },
      AUTOMATIONS: {
        id: 8,
        title: 'Automations',
        href: '/admin/workflows',
        allowedPermissions: [Permission.ADMIN, Permission.WORKFLOWS_MANAGEMENT],
        shouldShow: () => !isWhiteLabel,
      },
      ENTERPRISE: {
        id: 9,
        title: 'Enterprise',
        allowedPermissions: [Permission.ADMIN],
        options: [
          { title: 'General', href: '/admin/settings/enterprise', shouldShow: () => !isWhiteLabel },
          {
            title: 'Theming',
            href: '/admin/settings/enterprise/theming',
            shouldShow: () => !isWhiteLabel,
          },
          { title: 'Custom User Attributes', href: '/admin/settings/enterprise/custom_attributes' },
          ...(isFeatureEnabled('fy26_q2_enterprise_ai_settings')
            ? [{ title: 'AI Settings', href: '/admin/settings/enterprise/ai_settings' }]
            : []),
        ],
      },
    },
  },
};

if (isFeatureEnabled('fy25_q1_agents')) {
  WorkRampAdminAppOptions.AGENTS = {
    id: 10,
    title: 'Agents',
    href: '/admin/agents',
    src: '/images/vertnav_training_icon.svg',
    icon: 'ai',
    iconName: 'ai:regular',
    allowedPermissions: [Permission.ADMIN],
    sortOrder: 9,
  };
}

if (user?.enterprise?.cmsEnabled) {
  WorkRampAdminAppOptions.CMS = {
    id: 9,
    title: 'CMS',
    href: '/admin/cms',
    icon: 'file',
    iconName: 'file:regular',
    allowedPermissions: [Permission.ADMIN, Permission.CMS_MANAGEMENT],
    shouldShow: () => !isWhiteLabel,
    sortOrder: 2,
  };
}
if (isFeatureEnabled('fy25_q2_elc_skills')) {
  WorkRampAdminAppOptions.SETUP.submenus.SKILLS = {
    id: 5,
    title: 'Skills',
    href: '/admin/skills',
    allowedPermissions: [Permission.ADMIN],
    shouldShow: () => !isWhiteLabel,
  };
}

if (!isFeatureEnabled('fy25_q1_marketplace-global-navigation')) {
  WorkRampAdminAppOptions.MARKETPLACE = {
    id: 6,
    shouldShow: () => isFeatureEnabled('content_marketplace') && !isWhiteLabel,
    sortOrder: 6,
    title: 'Marketplace',
    href: APP_CONSTANTS.DEFAULT_CONTENT_MARKETPLACE_URL,
    src: '/images/vertnav_marketplace_icon.svg',
    icon: 'marketplace',
    iconName: 'marketplace:regular',
    allowedPermissions: [Permission.ADMIN, Permission.ACADEMY_ADMIN],
    target: '_blank',
  };
}

export default WorkRampAdminAppOptions;
